// src/config.js

const API_BASE_URL = "https://api.skillascent.in/api"; 

export default API_BASE_URL;